import React, { useState } from 'react'
import LogoDark from '../../assets/newLogo.svg'
import { BasicLink } from '../Link'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'

interface MobileHeaderWrapperProps {
  isOpen: boolean
}

const MobileHeaderTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 70px;
  padding: 8px 24px;
  position: fixed;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme.bg1};
  backdrop-filter: blur(20px);
  border-bottom: 1px solid ${({ theme }) => theme.bg3};
  z-index: 100;

  @media (min-width: 768px) {
    display: none;
  }
`

const MobileLogoContainer = styled.div`
  height: 36px;
  width: 120px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

const MobileMenuButton = styled.div`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`
const MobileHeaderWrapper = styled.div<MobileHeaderWrapperProps>`
  ${({ theme }) => theme.flexColumn}
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100% - 70px);
  background: ${({ theme }) => theme.bg1};
  transform: translateX(${({ isOpen }) => (isOpen ? '0' : '-100%')});
  transition: transform 0.3s ease-in-out;
  z-index: 99;
`

const MobileCloseButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 101;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
    color: ${({ theme }) => theme.text1};
  }

  &:hover svg {
    color: white;
  }
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  height: 60px;
  justify-content: space-between;
  position: fixed;
  padding: 12px 24px;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.bg1};
  backdrop-filter: blur(20px);
  border-bottom: 1px solid ${({ theme }) => theme.bg3};
  display: none;

  @media (min-width: 768px) {
    display: flex;
  }

  @media (min-width: 1200px) {
    padding: 12px 48px;
  }
`

// ... (other imports)

// ... (other imports)

const MobileLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-top: 20px;
  width: 100%;
  padding: 0 20px;
`

const MobileMenuItem = styled.a`
  position: relative;
  padding: 12px 16px;
  text-decoration: none;
  color: ${({ theme }) => theme.text1};
  display: block;
  font-size: 20px;
  font-weight: 700;
  margin: 10px 20px;
  width: -webkit-fill-available;

  &:hover {
    color: white;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: ${({ theme }) => theme.bg3};
  }
`

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  margin-right: 16px;
  width: fit-content;
  flex-shrink: 0;

  :hover {
    cursor: pointer;
  }

  img {
    width: 140px;
    height: auto;

    @media (max-width: 1200px) {
      width: 120px;
    }

    @media (max-width: 1000px) {
      width: 100px;
    }
  }
`

const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-start;
  gap: 16px;
  white-space: nowrap;

  @media (max-width: 1200px) {
    gap: 12px;
  }

  @media (max-width: 1000px) {
    gap: 8px;
  }
`

const DropdownMenu = styled.div`
  position: absolute;
  display: none;
  flex-direction: column;
  background-color: ${({ theme }) => theme.bg2};
  border: 1px solid ${({ theme }) => theme.bg3};
  border-radius: 8px;
  min-width: 160px;
  z-index: 1;
`

// const FarmingDropdown = styled.div`
//   position: relative;
//   display: inline-block;

//   &:hover ${DropdownMenu} {
//     display: flex;
//   }
// `

const MenuItem = styled.a`
  padding: 8px 12px;
  text-decoration: none;
  color: ${({ theme }) => theme.text1};
  display: block;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;

  &:hover {
    color: white;
  }

  @media (max-width: 1200px) {
    padding: 6px 8px;
    font-size: 13px;
  }

  @media (max-width: 1000px) {
    padding: 4px 6px;
    font-size: 12px;
  }
`

const FarmingDropdownMenu = styled(DropdownMenu)`
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  flex-direction: column;
  background-color: ${({ theme }) => theme.bg2};
  border: 1px solid ${({ theme }) => theme.bg3};
  border-radius: 8px;
  min-width: 160px;
  z-index: 1;
`

const FarmingDropdown = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${FarmingDropdownMenu} {
    display: flex;
  }
`

export default function Header() {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }
  return (
    <>
      {isMobile ? (
        <>
          <MobileHeaderTop>
            <MobileLogoContainer>
              <BasicLink to={'/home'}>
                <img src={LogoDark} alt="logo" />
              </BasicLink>
            </MobileLogoContainer>
            <MobileMenuButton onClick={toggleMenu}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 19H21" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 5H21" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 12H21" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </MobileMenuButton>
          </MobileHeaderTop>
          <MobileHeaderWrapper isOpen={isOpen}>
            <MobileCloseButton onClick={closeMenu}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 6L6 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 6L18 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </MobileCloseButton>
            <MobileLinksContainer>
              <MobileMenuItem href="/charts" onClick={closeMenu}>
                Charts
              </MobileMenuItem>
              <MobileMenuItem href="https://app.ixswap.io/#/launchpad">Launchpad</MobileMenuItem>
              <MobileMenuItem href="https://app.ixswap.io/#/security-tokens/tokens">Security Tokens</MobileMenuItem>
              <MobileMenuItem href="https://app.ixswap.io/#/pool">Liquidity Pools</MobileMenuItem>
              <MobileMenuItem href="https://app.ixswap.io/#/swap">Swap/Trade</MobileMenuItem>
              <FarmingDropdown>
                <MobileMenuItem>Farming</MobileMenuItem>
                <FarmingDropdownMenu>
                  <MenuItem href="https://ixswap.defiterm.io/">Live Pools</MenuItem>
                  <MenuItem href="https://app.ixswap.io/#/vesting">Token Sale Distributions</MenuItem>
                </FarmingDropdownMenu>
              </FarmingDropdown>
            </MobileLinksContainer>
          </MobileHeaderWrapper>
        </>
      ) : (
        <HeaderWrapper>
          <Title as={BasicLink} to={'/home'}>
            <img src={LogoDark} alt="logo" />
          </Title>
          <LinksContainer>
            <MenuItem href="/charts">Charts</MenuItem>
            <MenuItem href="https://app.ixswap.io/#/launchpad">Launchpad</MenuItem>
            <MenuItem href="https://app.ixswap.io/#/security-tokens/tokens">Security Tokens</MenuItem>
            <MenuItem href="https://app.ixswap.io/#/pool">Liquidity Pools</MenuItem>
            <MenuItem href="https://app.ixswap.io/#/swap">Swap/Trade</MenuItem>
            <FarmingDropdown>
              {/* <MenuItem> */}
              {/*   Farming {/1* <StyledIcon> *1/} */}
              {/*   <DropDown style={{ marginTop: '1px', width: '10px', height: '10px' }} /> */}
              {/*   {/1* </StyledIcon> *1/} */}
              {/* </MenuItem> */}
              <FarmingDropdownMenu>
                <MenuItem href="https://ixswap.defiterm.io/">Live Pools</MenuItem>
                <MenuItem href="https://app.ixswap.io/#/vesting">Token Sale Distributions</MenuItem>
              </FarmingDropdownMenu>
            </FarmingDropdown>
          </LinksContainer>
          {/* {!hideButton && (
            <IXSwapButton href={getIxswapAppLink()}>
              <p style={{ color: 'white' }} color={'white'}>
                Go to IXSwap Prime
              </p>
            </IXSwapButton>
          )} */}
        </HeaderWrapper>
      )}
    </>
  )
}
